import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getBuildingById, updateBuilding } from '../../store/buildings';

function UpdateBuilding() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.session.user);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    building_name: '',
    building_door_number: '',
    account_id: sessionUser?.account_id || '',
    created_at: '',
    updated_at: ''
  });

  useEffect(() => {
    const fetchBuilding = async () => {
      try {
        const buildingData = await dispatch(getBuildingById(id));
        setFormData({
          building_name: buildingData.building_name || '',
          building_door_number: buildingData.building_door_number || '',
          account_id: buildingData.account_id || sessionUser?.account_id || '',
          created_at: buildingData.created_at || '',
          updated_at: buildingData.updated_at || ''
        });
      } catch (error) {
        console.error('Error fetching building:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBuilding();
  }, [id, dispatch, sessionUser?.account_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        id: parseInt(id),
        building_name: formData.building_name,
        building_door_number: parseInt(formData.building_door_number),
        account_id: formData.account_id
      };
      await dispatch(updateBuilding(dataToSend));
      history.push(`/buildings/${id}`);
    } catch (error) {
      console.error('Error updating building:', error);
    }
  };

  if (loading) return <div className="p-5 text-7xl">Loading...</div>;

  return (
    <div className="p-5 min-h-[calc(100vh-100px)] flex flex-col">
      <div className="max-w-6xl mx-auto w-full">
        <h1 className="text-8xl font-bold mb-5 text-center text-blue-600">Update Building</h1>
        <form onSubmit={handleSubmit} className="flex-grow bg-white rounded-lg p-8 shadow-md">
          <div className="space-y-6">
            <div>
              <label className="text-3xl font-semibold">Building Name</label>
              <input
                id='building_name'
                type="text"
                name="building_name"
                value={formData.building_name}
                onChange={handleChange}
                className="w-full mt-2 p-3 text-2xl rounded-lg border border-gray-300 bg-gray-100"
              />
            </div>

            <div>
              <label className="text-3xl font-semibold">Number of Dock Doors</label>
              <input
                id='building_door_number'
                type="number"
                name="building_door_number"
                value={formData.building_door_number}
                onChange={handleChange}
                className="w-full mt-2 p-3 text-2xl rounded-lg border border-gray-300"
              />
            </div>

            <div className="flex justify-end gap-4">
              <button
                id='cancel-building-button'
                type="button"
                onClick={() => history.push(`/buildings/${id}`)}
                className="px-6 py-3 text-2xl text-gray-700 bg-gray-200 rounded-lg transition-all duration-200
                  hover:bg-gray-300 hover:shadow-md hover:scale-[1.02]"
              >
                Cancel
              </button>
              <button
                id='update-building-button'
                type="submit"
                className="px-6 py-3 text-2xl bg-blue-600 text-white rounded-lg transition-all duration-200
                  hover:bg-blue-700 hover:shadow-md hover:scale-[1.02]"
              >
                Update Building
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateBuilding;
